import { render, staticRenderFns } from "./RollAcitvityDetail.vue?vue&type=template&id=41750390&"
import script from "./RollAcitvityDetail.vue?vue&type=script&lang=js&"
export * from "./RollAcitvityDetail.vue?vue&type=script&lang=js&"
import style0 from "./RollAcitvityDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports